import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './LegalPage.css';

// Renders a structured legal/business page from plain data so every page looks consistent & premium.
// A `body` node is either a string (paragraph), { h: 'sub-heading' }, { list: [...] }, or { note: '...' }.
function Body({ nodes }) {
  return (
    <React.Fragment>
      {nodes.map((node, i) => {
        if (typeof node === 'string') return <p key={i}>{node}</p>;
        if (node.h) return <h3 key={i} className={s.subH}>{node.h}</h3>;
        if (node.list) return (
          <ul key={i} className={s.list}>
            {node.list.map((li, j) => <li key={j}>{li}</li>)}
          </ul>
        );
        if (node.note) return <p key={i} className={s.note}>{node.note}</p>;
        return null;
      })}
    </React.Fragment>
  );
}

const LegalPage = ({ page = {} }) => {
  const { eyebrow, title, updated, intro, sections = [], toc = true } = page;
  const showToc = toc && sections.length > 3;

  return (
    <div className={s.page}>
      <header className={s.hero}>
        <div className={s.wrap}>
          {eyebrow ? <span className={s.eyebrow}>{eyebrow}</span> : null}
          <h1 className={s.h1}>{title}</h1>
          {updated ? <p className={s.updated}>Last updated: {updated}</p> : null}
          {intro ? <p className={s.intro}>{intro}</p> : null}
        </div>
      </header>

      <div className={s.wrap}>
        <div className={showToc ? s.layout : s.layoutNarrow}>
          {showToc ? (
            <nav className={s.toc} aria-label="On this page">
              <span className={s.tocTitle}>On this page</span>
              <ul>
                {sections.map((sec) => (
                  <li key={sec.id}><a href={`#${sec.id}`}>{sec.heading}</a></li>
                ))}
              </ul>
            </nav>
          ) : null}

          <article className={s.body}>
            {sections.map((sec) => (
              <section id={sec.id} key={sec.id} className={s.section}>
                <h2 className={s.h2}>{sec.heading}</h2>
                <Body nodes={sec.body || []} />
              </section>
            ))}
          </article>
        </div>
      </div>
    </div>
  );
};

export default withStyles(s)(LegalPage);
